var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 9.12499C10.9583 9.12499 11.7673 8.7743 12.4271 8.07291C13.0868 7.37152 13.4166 6.52777 13.4166 5.54166V2.91666H6.58331V5.54166C6.58331 6.52777 6.91317 7.37152 7.5729 8.07291C8.23262 8.7743 9.04165 9.12499 9.99998 9.12499ZM3.33331 18.3333V17.0833H5.33331V14.4375C5.33331 13.4653 5.58679 12.5729 6.09373 11.7604C6.60067 10.9479 7.30554 10.3611 8.20831 9.99999C7.30554 9.63888 6.60067 9.0486 6.09373 8.22916C5.58679 7.40971 5.33331 6.51388 5.33331 5.54166V2.91666H3.33331V1.66666H16.6666V2.91666H14.6666V5.54166C14.6666 6.51388 14.4132 7.40971 13.9062 8.22916C13.3993 9.0486 12.6944 9.63888 11.7916 9.99999C12.6944 10.3611 13.3993 10.9479 13.9062 11.7604C14.4132 12.5729 14.6666 13.4653 14.6666 14.4375V17.0833H16.6666V18.3333H3.33331Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.8408ebc82d922ba45f168f9a4c5895a3.svg";
export { ForwardRef as ReactComponent };